import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Inspection } from '../../../class/inspection';
import { InspectionService } from '../../../service/inspection/inspection.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule, Message } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { InspectionEquipment } from '../../../class/inspection-equipment';
import { InspectionEquipmentService } from '../../../service/inspection-equipment/inspection-equipment.service';
import { config } from '../../../../../../environments/config';
import { id } from '@swimlane/ngx-charts/release/utils';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { formatDateWithoutHour } from '../../../../../theme/functions/formatDateWithoutHour.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-inspection',
  templateUrl: './new-inspection.component.html',
  styleUrls: ['./new-inspection.component.scss']
})
export class NewInspectionComponent implements OnInit {
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Inspection;
    @Output() reload: EventEmitter<number> = new EventEmitter<number>();
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public save_exit: boolean;
    public es: any;

    public station_id: AbstractControl;
    public inspection_date: AbstractControl;
    public maintenance_assistant_id: AbstractControl;
    public service_manager_id: AbstractControl;

    public employeePositionToLoadMaintenanceAssistant: string;
    public employeePositionToLoadManager: string;

    public equipments: InspectionEquipment[];
    public totalRecordsEquipments: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public inspection_equipment_id: Array<number>;
    public trademark: FormArray;
    public model: FormArray;
    public state: FormArray;
    public type: FormArray;
    public capacity: FormArray;
    public serial: FormArray;
    public observations: FormArray;

    public stateOptions: SelectItem[];

    public uploadedFileEquipments: any[] = [];
    public prewiewFileEquipments: any;
    public promiseFileEquipments: Promise<any>;
    public msgs: Message[];
    public apiUrl = config.API_ROOT;

    constructor(
        fb: FormBuilder,
        public inspectionService: InspectionService,
        public inspectionEquipmentService: InspectionEquipmentService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        private ngZone: NgZone) {

        this.equipments = [];
        this.inspection_equipment_id = [];
        this.employeePositionToLoadMaintenanceAssistant = '3';
        this.employeePositionToLoadManager = '2';

        this.es = calendarES();

        this.stateOptions = [
            {label: 'choose', value: ''},
            {label: 'Bueno', value: 'Bueno'},
            {label: 'Malo', value: 'Malo'},
            {label: 'No Aplica', value: 'No Aplica'},
        ];

        this.save_exit = false;

        this.form = fb.group({
          'station_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'inspection_date': ['', Validators.compose([Validators.required])],
          'maintenance_assistant_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'service_manager_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
        });
        this.station_id = this.form.controls['station_id'];
        this.inspection_date = this.form.controls['inspection_date'];
        this.maintenance_assistant_id = this.form.controls['maintenance_assistant_id'];
        this.service_manager_id = this.form.controls['service_manager_id'];

        this.trademark = new FormArray([]);
        this.model = new FormArray([]);
        this.state = new FormArray([]);
        this.type = new FormArray([]);
        this.capacity = new FormArray([]);
        this.serial = new FormArray([]);
        this.observations = new FormArray([]);
    }

    ngOnInit() {

        this.page = 1;
        this.per_page = 1000;
        this.sort = 'group';
        this.getInspectionEquipments();

        if (this.edit) {
          this.station_id.setValue(this.edit.station_id);
          this.inspection_date.setValue(new Date(this.edit.inspection_date));
          this.maintenance_assistant_id.setValue(this.edit.maintenance_assistant_id);
          this.service_manager_id.setValue(this.edit.service_manager_id);
        }
    }

    public cancelInspection () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newInspection(values);
    }

    public newInspection(values: Inspection) {
        let item = [];
        let i = 0;
        this.trademark.value.forEach(element => {
            item.push(
                {'trademark': this.trademark.value[i],
                'model': this.model.value[i],
                'state': this.state.value[i],
                'type': this.type.value[i],
                'capacity': this.capacity.value[i],
                'serial': this.serial.value[i],
                'observations': this.observations.value[i],
                'inspection_equipment_id': this.inspection_equipment_id[i]}
            );
            i++;
        });

        const param = {
          'station_id': values.station_id.id,
          'inspection_date': formatDateWithoutHour(values.inspection_date),
          'maintenance_assistant_id': values.maintenance_assistant_id.id,
          'service_manager_id': values.service_manager_id.id,
          'inspection_has_equipments': item,
          };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.inspectionService.updateInspection(this.edit.id, param)
                :
                this.inspectionService.newInspection(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        } else {
                            let id = response.json().id;
                            this.reload.emit(response.json().id);
                        }

                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        });
                    });
                }
            );
        }
    }

    public onUploadFileEquipment(event: any, id) {
      let i = this.findElement(this.edit.inspection_has_equipment, id);
        for (const file of event.srcElement.files) {
            this.uploadedFileEquipments[i]=file;
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewFileEquipments[i] = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateFileEquipment(event: any, id) {
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

        let i = this.findElement(this.edit.inspection_has_equipment, id);
        let a = this.edit.inspection_has_equipment[i].id;
        for (const file of event.files) {
            this.uploadedFileEquipments[i]=file;
        }

        this.promiseFileEquipments = this.uploadFilesService.updateFileEquipment(this.uploadedFileEquipments[i], a).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public gotoFileEquipment(id) {
      let i = this.findElement(this.edit.inspection_has_equipment, id);
      i = this.edit.inspection_has_equipment[i].id;
        window.open(this.apiUrl + '/inspection-has-equipments/' + i + '/file-equipment'  + '?token=' + localStorage.getItem('token'), '_blank');
    }

  public getInspectionEquipments(query?: string) {
    this.inspectionEquipmentService.getInspectionEquipment(this.page, this.per_page, this.sort, query).toPromise().then(
        response => {
            this.equipments = response.json().data;

            this.equipments.forEach(element => {
                this.addItem(element.id);
            });
            if (response.json().meta.total > response.json().meta.total_filtered) {
                this.totalRecordsEquipments = response.json().meta.total_filtered;
            } else {
                this.totalRecordsEquipments = response.json().meta.total;
            }
        },
        error => {
          let msg = '';
          this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
              this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach(element => {
                      if (element.source) {
                          if (element.source.pointer) {
                              this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                  msg = msg + res3 + ', ';
                              });
                          }
                      }
                  });
                  this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  // this.msg.emit( { severity: 'error', summary: 'Error' } );
              });
          });
    });
  }

  public findElement (list, search) {
    let find = -1;
    let itera = 0;
    list.forEach(element => {
        if (element.inspection_equipment_id === search) {
            find = itera;
        }
        itera++;
    });
    return find;
  }

  addItem(id) {
    this.inspection_equipment_id.push(id);
    let trademark = 'N/A';
    let model = 'N/A';
    let state = 'No Aplica';
    let type = 'N/A';
    let capacity = 'N/A';
    let serial = 'N/A';
    let observations = 'N/A';
    let file_equipment = {'name': 'No Hay Archivo Adjunto'};
    if (this.edit) {
      if (this.edit.inspection_has_equipment.length > 0) {
        let i = this.findElement(this.edit.inspection_has_equipment, id);
        if (i >= 0) {
            if (this.edit.inspection_has_equipment[i].trademark == ""){
                trademark = "N/A";
            } else {
                trademark = this.edit.inspection_has_equipment[i].trademark;
            }

            if (this.edit.inspection_has_equipment[i].model == "") {
                model = "N/A"
            } else {
                model = this.edit.inspection_has_equipment[i].model;
            }

            if (this.edit.inspection_has_equipment[i].state  == "") {
                state = 'No Aplica'
            } else {
                state = this.edit.inspection_has_equipment[i].state;
            }

            if (this.edit.inspection_has_equipment[i].type == "") {
                type = "N/A"
            } else {
                type = this.edit.inspection_has_equipment[i].type;
            }
            
            if (this.edit.inspection_has_equipment[i].capacity  == "") {
                capacity = "N/A"
            } else {
                capacity = this.edit.inspection_has_equipment[i].capacity;
            }

            if (this.edit.inspection_has_equipment[i].serial  == "") {
                serial = "N/A"
            } else {
                serial = this.edit.inspection_has_equipment[i].serial;
            }

            if (this.edit.inspection_has_equipment[i].observations  == "") {
                observations = 'N/A'
            } else {
                observations = this.edit.inspection_has_equipment[i].observations;
            }

            if ((this.edit.inspection_has_equipment[i].file_equipment  != null) && (this.edit.inspection_has_equipment[i].file_equipment  != "")) {
                file_equipment = {'name':this.edit.inspection_has_equipment[i].file_equipment};
            }
        }
      }
    }
    this.trademark.push(new FormControl(trademark, Validators.required));
    this.model.push(new FormControl(model, Validators.required));
    this.state.push(new FormControl(state, Validators.required));
    this.type.push(new FormControl(type, Validators.required));
    this.capacity.push(new FormControl(capacity, Validators.required));
    this.serial.push(new FormControl(serial, Validators.required));
    this.observations.push(new FormControl(observations, Validators.required));
    this.uploadedFileEquipments.push(file_equipment);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspections/new-inspection/new-inspection.component.ts